// export *                      from './organisation.class';

export *                from './organisation-info.component';

export { Organisation } from '@Common/Elements/Organisation/';